import styled from "styled-components";
import logo from "../../assets/logo-desafio.png";

export const Container = styled.section``;

export const Content = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  margin: 0 auto;
  padding: 48px;

  @media screen and (max-width: 930px) {
    flex-direction: column;
  }
`;

export const Aside = styled.aside`
  width: 100%;
  max-width: 330px;
  margin-right: 96px;

  @media screen and (max-width: 930px) {
    max-width: 100%;
    margin-bottom: 48px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  @media screen and (max-width: 930px) {
    display: flex;
    align-items: center;
    max-width: 100%;
  }

  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
`;

export const BackButton = styled.button.attrs({
  type: "button",
})`
  display: flex;
  align-items: center;
  padding: 8px;
  color: #fff;
  transition: 300ms ease;
  margin-bottom: 32px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;

  svg {
    margin-right: 8px;
    transition: 300ms ease;
  }

  :hover {
    svg {
      transform: translateX(-4px);
    }
  }
`;

export const Logo = styled.img.attrs({
  src: logo,
})`
  margin-bottom: 32px;

  @media screen and (max-width: 930px) {
    margin-bottom: 0;
    margin-right: 32px;
  }

  @media screen and (max-width: 640px) {
    margin-bottom: 32px;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 100%;
  }
`;

export const Info = styled.article`
  font-size: 16px;
  line-height: 24px;
  opacity: 0.8;
  p {
    margin-bottom: 24px;
    span {
      font-weight: bold;
    }
  }
`;
